
const experience = [
    {
        id: 1,
        title: 'Desarrollador Fullstack',
        workplace: 'Forus',
        location: 'Santiago, Chile (remoto)',
        workplaceUrl: 'https://',
        workplaceIcon: './companies/forus.png',
        description: 'Diseño, desarrollo y mantención de múltiples aplicaciones (Mobile, Frontend y Backend)',
        technologies: ['Spring Framework','React.js','React Native','AWS'],
        dateRange: 'Enero 2022 - Actualmente',
    },
    {
        id: 2,
        title: 'Ingeniero de Software',
        workplace: 'Equifax',
        location: 'Santiago, Chile (remoto)',
        workplaceUrl: 'https://',
        workplaceIcon: './companies/equifax.png',
        description: 'Desarrollo, testing y mantención de múltiples aplicaciones bajo la arquitectura de microservicios en ambiente cloud',
        technologies: ['Spring Framework','JUnit','Mockito','Hashicorp Vault','SonarQube','AWS','GCP','Jenkins'],
        dateRange: 'Julio 2021 - Enero 2022',
    },
    {
        id: 3,
        title: 'Desarrollador Frontend',
        workplace: 'CreaLab',
        location: 'Temuco, Chile (remoto)',
        workplaceUrl: 'https://',
        workplaceIcon: './companies/crealab.png',
        description: 'Diseño e implementación a nivel de Frontend de plataforma educativa (PWA) en un equipo multidisciplinario',
        technologies: ['Vue.js','Vuex','TailwindCSS'],
        dateRange: 'Abril 2020 - Julio 2020',
    },
    {
        id: 4,
        title: 'Integrador servicios Smart City',
        workplace: 'Smart Araucanía',
        location: 'Temuco, Chile',
        workplaceUrl: 'https://',
        workplaceIcon: './companies/smart-araucania.png',
        description: 'Implementación de framework Fiware para soluciones inteligentes con sus múltiples microservicios, además de servicios para visualizar datos y servicios intermedios para conectar APIs',
        technologies: ['Fiware','Docker','Node.js','Angular','Spring Boot','Stack ELK','Grafana','AWS'],
        dateRange: 'Abril 2020 - Julio 2020',
    },
];

export default experience;